/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import classNames from 'classnames';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import shortid from 'shortid';
import Point from 'atoms/Point/Point';
import LoaderSvg from 'images/v5/icons/loader.svg';
import { openModal } from 'store/layoutSlice';
import { updateProjectionPoint } from 'store/specificationProjectionsSlice';
import styles from './Playground.module.scss';
function Playground({ preview, zoom, picture, points, loading }) {
    const { t } = useTranslation(['specification']);
    const dispatch = useDispatch();
    const containerRef = useRef(null);
    const zoomValue = zoom / 100;
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);
    const [startDrag, setStartDrag] = useState({ x: 0, y: 0 });
    const [startPos, setStartPos] = useState({ x: 0, y: 0 });
    const [localPoints, setLocalPoints] = useState([]);
    useEffect(() => {
        setLocalPoints(points);
    }, [points]);
    const handleMouseDown = (e) => {
        e.preventDefault();
        setIsDragging(true);
        setStartDrag({ x: e.clientX, y: e.clientY });
        setStartPos(position);
    };
    const handleMouseMove = useCallback((e) => {
        if (!isDragging)
            return;
        const deltaX = e.clientX - startDrag.x;
        const deltaY = e.clientY - startDrag.y;
        setPosition({
            x: startPos.x + deltaX,
            y: startPos.y + deltaY,
        });
    }, [isDragging, startDrag, startPos]);
    const handleMouseUp = () => {
        setIsDragging(false);
    };
    const handleClick = (e) => {
        var _a, _b;
        const isDraggable = (_a = e.target) === null || _a === void 0 ? void 0 : _a.closest('[data-draggable]');
        if (isDraggable)
            return;
        if (!((_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.contains(e.target)))
            return;
        const rect = containerRef.current.getBoundingClientRect();
        const x = (e.clientX - rect.left) / zoomValue;
        const y = (e.clientY - rect.top) / zoomValue;
        dispatch(openModal({ name: 'commentCreator', data: { x, y, noteX: x - 150, noteY: y - 80 } }));
    };
    const handleMovePoint = (id, newPin, newNote) => {
        setLocalPoints((prev) => prev.map((p) => p.id === id ? Object.assign(Object.assign({}, p), { x: newPin.x, y: newPin.y, noteX: newNote.x, noteY: newNote.y }) : p));
    };
    const handleDragEnd = (id, newPin, newNote) => {
        setLocalPoints((prev) => prev.map((p) => p.id === id ? Object.assign(Object.assign({}, p), { x: newPin.x, y: newPin.y, noteX: newNote.x, noteY: newNote.y }) : p));
        dispatch(updateProjectionPoint({
            projectionPointId: id,
            x: newPin.x,
            y: newPin.y,
            noteX: newNote.x,
            noteY: newNote.y,
        }));
    };
    useEffect(() => {
        if (isDragging) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
        }
        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isDragging, handleMouseMove]);
    const bounds = {
        width: 750,
        height: 650,
    };
    return (React.createElement("div", { className: styles.wrap },
        React.createElement("div", { className: styles.container, ref: containerRef, onMouseDown: handleMouseDown, onDoubleClick: handleClick, style: {
                width: `${bounds.width * zoomValue}px`,
                height: `${bounds.height * zoomValue}px`,
                padding: `${50 * zoomValue}px`,
                transform: `translate(${position.x}px, ${position.y}px)`,
                transformOrigin: 'center center',
                cursor: isDragging ? 'grabbing' : 'grab',
                position: 'relative',
            } },
            React.createElement("img", { src: picture, className: styles.image, draggable: false, alt: "" }),
            (localPoints === null || localPoints === void 0 ? void 0 : localPoints.length) > 0 ? (localPoints === null || localPoints === void 0 ? void 0 : localPoints.map((point) => {
                var _a;
                return (React.createElement(Point, { preview: preview, key: point.id, id: point.id, pin: { x: point.x, y: point.y }, note: { x: point.noteX, y: point.noteY }, desc: point === null || point === void 0 ? void 0 : point.note, component: point === null || point === void 0 ? void 0 : point.component, picture: (_a = point === null || point === void 0 ? void 0 : point.photo) === null || _a === void 0 ? void 0 : _a.slice(1, -1), zoom: zoomValue, bounds: bounds, onMove: (newPin, newNote) => handleMovePoint(point.id, newPin, newNote), onDragEnd: (newPin, newNote) => handleDragEnd(point.id, newPin, newNote) }));
            })) : (React.createElement("div", { id: shortid(), style: {
                    display: preview ? 'none' : 'block',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
                    border: '1px solid var(--static-stroke-strong)',
                    borderRadius: '6px',
                    maxWidth: '230px',
                    padding: '12px',
                    background: 'var(--static-fill-foreground)',
                } }, t('projection_points_empty_state')))),
        React.createElement("div", { className: classNames(styles.loader, { [styles.active]: loading }) },
            React.createElement(LoaderSvg, null))));
}
export default Playground;
